const CODE_REVOKE_REQUEST = 'CODE_REVOKE_REQUEST';
const CODE_REVOKE_SUCCESS = 'CODE_REVOKE_SUCCESS';
const CODE_REVOKE_FAILURE = 'CODE_REVOKE_FAILURE';

export {
  CODE_REVOKE_REQUEST,
  CODE_REVOKE_SUCCESS,
  CODE_REVOKE_FAILURE,
};
